<template>
    <div class="form-check gtc-form" :class="{ 'error': showError }">
        <input class="form-check-input gtc-checkbox" type="checkbox" :id="'privacy-policy-accept' + _uid" :checked="value" @change="onValueChanged($event.target.checked)">
        <label class="form-check-label gtc-label" :for="'privacy-policy-accept' + _uid">
            <span v-html="labelHtml"></span><!--
            --><sup>*</sup>
        </label>
    </div>
</template>

<script>
export default {

    name: "accept-privacy-policy-check",

    props: {
        value: Boolean ,
        showError: Boolean
    },

    computed: {
        labelHtml()
        {
            const contactPrivacyPolicy = this.$translate("Ceres::Template.contactPrivacyPolicy", {"hyphen": "&shy;"});
            const html = `
                <!----><a href="${ App.urls.privacyPolicy }" target="_blank" class="text-appearance">
                    <span>${ contactPrivacyPolicy }</span>
                </a><!---->
            `;

            return this.$translate("Weberbuero::Template.singleMusterModalPrivacyPolicy", {policy: html});
        }
    },

    methods:
    {
        onValueChanged(value)
        {
            this.$emit("input", value);
        }
    }
}
</script>
